import React, { Children, FunctionComponent, ReactNode } from "react";
import "./Tab.css";

interface TabsProps {
    children: any
}
 
interface TabsState {
    
}
 
class Tabs extends React.Component<TabsProps, TabsState> {
    constructor(props : TabsProps){
        super(props);
    }

    render() { 
        return (  
            <div className="tab-block">
                {this.props.children}
            </div>
        );
    }
}

type TabsContainerProps = {
    children: JSX.Element[] | JSX.Element
}

export const TabsContainer:FunctionComponent<TabsContainerProps> = (props) => {
    return <div className="tab-container">{props.children}</div>
}

type TabNavigationProps = {
    children: JSX.Element[] | JSX.Element
}

export const TabNavigation:FunctionComponent<TabNavigationProps> = (props) => {
    return <div className="tab-navigation">{props.children}</div>
}

type TabNavigationElementProps = {
    title:string,
    tooltip?: number | Promise<number>,
    isActive?: boolean,
    onClick?: ()=> void
}

export const TabNavigationElement:FunctionComponent<TabNavigationElementProps> = (props) => {
    let {title, tooltip, isActive, onClick} = props
    return <a role="button" className={`tab-navigation__elem ${isActive ? 'active' : ''}`} onClick={onClick}>
        <>
        {title} {!!tooltip && <span className="alert-tooltip">{tooltip}</span>}
        </>
    </a>
}

type TabElementProps = {
    children: JSX.Element,
    isActive?: boolean,
}

export class TabElement extends React.Component<TabElementProps, TabsState> {
    render() {
        return <div className={`tab-container__elem ${this.props.isActive ? 'active' : ''}`}>{this.props.children}</div>
    }
}

export default Tabs;